import React, { Component } from 'react';
import { PhoneIcon } from '@eg/elements/Icons/PhoneIcon';

import "./Header.scss";

class Header extends Component {
  render() {
    return (
      <nav className="navigation_wrapper">
        <div className="navigation">
          <div className="navigation_left">
            <a href="https://www.ergo.de/" className="logo">
              <img alt="ERGO Logo" src={process.env.PUBLIC_URL + "/statics/svg/ergo-logo.svg"} height="19,5"/>
            </a>
            <ul className="header_list">
              <li className="list_item_logo">
                Internetschutzbrief
              </li>
            </ul>
          </div>
          <div className="navigation_right">
            <div className="vertical_line"></div>
            <ul>
              <li className="list_item">
                <a href="tel:08006669000" className="phone"><PhoneIcon width="24" height="24"/>
                  <span className="phoneNumber">0800 / 999 4580</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    )
  }
}

export default Header;
